
(() => {
  const normalize = (tag) => String(tag).trim().toLowerCase();
  const usableTags = (tags) => new Set(tags.map(normalize).filter(tag => tag && tag !== 'custom khong bat buoc'));
  const score = (source, tags) => [...usableTags(tags)].filter(tag => source.has(tag)).length;
  if (customElements.get('tag-recommendations')) return;
  customElements.define('tag-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.loadByTags();
    }

    async loadByTags() {
      const grid = this.querySelector('[data-tag-grid]');
      const heading = this.querySelector('[data-tag-heading]');
      const source = usableTags(JSON.parse(this.dataset.productTags || '[]'));
      const limit = Number(this.dataset.limit) || 4;
      if (source.size < 3) {
        this.hidden = true;
        return;
      }
      heading.hidden = grid.children.length === 0;
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      const scopedUrl = (path, section) => {
        const url = new URL(path, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid product origin');
        url.searchParams.set('section_id', section);
        if (preview) url.searchParams.set('preview_theme_id', preview);
        return url;
      };
      const parseResponse = async (url) => {
        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Tag recommendations unavailable');
        return new DOMParser().parseFromString(await response.text(), 'text/html');
      };
      try {
        const candidates = new Map();
        const root = this.dataset.root || '/';
        let url = scopedUrl(root.replace(/\/$/, '') + '/collections/all', 'tag-related-index');
        const seenPages = new Set();
        while (url && !seenPages.has(url.toString())) {
          seenPages.add(url.toString());
          const html = await parseResponse(url);
          const catalog = html.querySelector('[data-tag-catalog]');
          if (!catalog) throw new Error('Tag catalog was not rendered');
          for (const entry of catalog.querySelectorAll('[data-tag-entry]')) {
            if (entry.dataset.id === this.dataset.productId) continue;
            const shared = score(source, JSON.parse(entry.dataset.tags || '[]'));
            if (shared >= 3) candidates.set(entry.dataset.id, { id: entry.dataset.id, url: entry.dataset.url, score: shared });
          }
          if ([...candidates.values()].filter(candidate => candidate.score === source.size).length >= limit) break;
          url = catalog.dataset.next ? scopedUrl(catalog.dataset.next, 'tag-related-index') : null;
        }
        const ranked = [...candidates.values()].sort((a, b) => b.score - a.score).slice(0, limit);
        const cards = await Promise.all(ranked.map(async (candidate) => {
          const html = await parseResponse(scopedUrl(candidate.url, 'tag-related-card'));
          const card = html.querySelector('[data-tag-card]');
          if (!card || card.dataset.productId !== candidate.id) throw new Error('Product card mismatch');
          const item = document.createElement('li');
          item.className = 'grid__item';
          item.dataset.tagProductId = candidate.id;
          item.dataset.tagScore = candidate.score;
          item.innerHTML = card.innerHTML;
          return item;
        }));
        if (!this.isConnected) return;
        grid.replaceChildren(...cards);
        heading.hidden = cards.length === 0;
        this.hidden = cards.length === 0;
      } catch (error) {
        console.error(error);
        this.hidden = grid.children.length === 0;
      }
    }
  });
})();
